var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"session-card elevation-0 d-flex flex-column"},[_c('SessionCard',{attrs:{"agenda-event":this.session},on:{"sessionReload":_vm.sessionReload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }